
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningLightSleetShowersDay as ObiLightningLightSleetShowersDayElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-light-sleet-showers-day.js';
 
 
 

 
 export const ObiLightningLightSleetShowersDay = createComponent({
   react: React,
   tagName: 'obi-lightning-light-sleet-showers-day',
   elementClass: ObiLightningLightSleetShowersDayElement,
   events: {
     
   }
  });
 
 